export enum KeyboardShortcuts {
    ENTER = 'Enter',
    ESCAPE = 'Escape',
    SPACE = ' ',
    ARROW_UP = 'ArrowUp',
    ARROW_DOWN = 'ArrowDown',
    TAB = 'Tab'
}